import { View } from "@tarojs/components";
import classNames from "classnames";
import * as React from "react";
import { prefixClassname } from "../styles/index.js";
import Badge from "../badge/index.js";
import TabsLine from "./tabs-line.js";
export default function Tab(props) {
    const { className, active, disabled = false, underline, ellipsis, flexBasis, dot, badge, children, ...restProps } = props;
    return (React.createElement(View, { style: { flexBasis }, className: classNames(prefixClassname("tabs__tab"), {
            [prefixClassname("tabs__tab--active")]: active,
            [prefixClassname("tabs__tab--disabled")]: disabled,
        }, className), ...restProps },
        React.createElement(Badge, { dot: dot, content: badge },
            React.createElement(View, { className: classNames(prefixClassname("tabs__tab__content")) },
                React.createElement(View, { className: classNames({ [prefixClassname("tabs__tab__content-ellipsis")]: ellipsis }) }, children))),
        underline && React.createElement(TabsLine, { active: active })));
}
